/* IMPORT YOUR BRANDING/THEMING FIRST */
import './index.less';

import 'core-js';
import 'raf/polyfill';
import HttpsRedirect from 'react-https-redirect';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';

import unregister from './registerServiceWorker';
import { MainRoutes } from './routes';
import Localization from './containers/Localization/Localization';
import AppConfig from './containers/AppConfig/AppConfig';
import RootStore from './stores/RootStore';
import loadCookieScript from './utils/loadCookieScript';

(async () => {
  const rootStore = new RootStore();
  await rootStore.init();

  const stores = {
    RootStore: rootStore,
    AuthStore: rootStore.authStore,
    AuthZStore: rootStore.authZStore,
    ConfigStore: rootStore.configStore,
    GoogleAnalyticsStore: rootStore.googleAnalyticsStore,
    LocalizationStore: rootStore.localizationStore,
    MessagesStore: rootStore.messagesStore,
    ObservationsStore: rootStore.observationsStore,
    SafetyStore: rootStore.safetyStore,
    EventsStore: rootStore.eventsStore,
    NotificationsStore: rootStore.notificationsStore
  };

  const Root = (
    <Provider {...stores}>
      <HttpsRedirect>
        <Localization>
          <AppConfig>
            <MainRoutes />
          </AppConfig>
        </Localization>
      </HttpsRedirect>
    </Provider>
  );

  ReactDOM.render(Root, document.getElementById('root'));
  unregister();

  // Call loadCookieScript after render, using the same rootStore
  loadCookieScript(rootStore.configStore, window);
})();

// Code-splitting using react-router
// https://github.com/AnomalyInnovations/serverless-stack-demo-client/tree/code-splitting-in-create-react-app



// WEBPACK FOOTER //
// ./src/index.js